import services from './../../../services/service'; // Service Class
import MainFooter from './../../MainFooter/index.vue'; // Main Footer ///for first show orders
import Activities from './../../../resources/activity.js'; //Activity Class
let service = new services();

export default {
    name: 'Wishlist',
    mixins: [Activities],
    data () {
      return {
        loading:false,
        wishlist:{},
      }
    },

    methods: {
        
       
    },
    mounted: function(){
    },
    created: function(){
    }
}


// WEBPACK FOOTER //
// ./src/pages/Boxpoint/Wishlist/script.js